import { createActions, handleActions } from "redux-actions";
import { normalize } from "normalizr";

import { getData } from "../utilities";
import { story, storeStories } from "./stories";

/*
 *** ACTION CREATORS
 */

const actions = createActions({
  VIDEOS_PAGE: {
    REQUEST: [(payload) => payload, (_, page) => ({ page })],
    RESPONSE: [
      (payload) => payload,
      (_, page, nbrPages) => ({ page, nbrPages }),
    ],
  },
});

/*
 *** THUNKS
 */

export const fetchVideosPage =
  (page = 1) =>
  (dispatch) => {
    dispatch(actions.videosPage.request(undefined, page));

    return getData("/stories/", {
      schemes: "VIDEO,VIDEO_AUDIO",
      page,
      per_page: 12,
    })
      .then(async (res) => {
        if (res.status === 404) {
          return dispatch(
            actions.videosPage.response(new Error(res.status), page)
          );
        }

        if (res.status !== 200) {
          return dispatch(
            actions.videosPage.response(new Error(res.statusText), page)
          );
        }

        const results = (await res.json()).results;
        const videos = normalize(results, [story]);

        dispatch(storeStories(videos.entities.stories));

        return dispatch(
          actions.videosPage.response(
            videos.result,
            page,
            parseInt(res.headers.get("x-pagination-pages"), 10)
          )
        );
      })
      .catch((error) => dispatch(actions.videosPage.response(error, page)));
  };

/*
 *** REDUCERS
 */

export default handleActions(
  new Map([
    [
      actions.videosPage.request,
      (state, { meta }) => ({
        ...state,
        pages: {
          ...state.pages,
          [meta.page]: { isFetching: true, error: null },
        },
      }),
    ],
    [
      actions.videosPage.response,
      (state, { error, payload, meta }) => {
        if (error) {
          return {
            ...state,
            pages: {
              ...state.pages,
              [meta.page]: {
                isFetching: false,
                error: payload.message,
              },
            },
          };
        }

        return {
          pages: {
            ...state.pages,
            [meta.page]: { isFetching: false, error: null, videos: payload },
          },
          nbrPages: meta.nbrPages,
        };
      },
    ],
  ]),
  {
    pages: {},
  }
);

/*
 *** SELECTORS
 */

export const getVideosPage = (state, page, storiesBySlug) => {
  const videoList = state.pages[page];

  if (!videoList) {
    return {
      isFetching: false,
      error: null,
      nbrPages: state.nbrPages,
      videos: [],
    };
  }

  return {
    isFetching: videoList.isFetching,
    error: videoList.error,
    nbrPages: state.nbrPages,
    videos: videoList.videos
      ? videoList.videos.map((slug) => storiesBySlug[slug])
      : [],
  };
};
